import {useMutation} from '@apollo/client';
import {CREATE_MANY_ORDER} from "../orderTypeDefs";

export const useMutationCreateManyOrders = (options?: any): any => (
  useMutation(CREATE_MANY_ORDER, options)
);
